"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGuestGuard = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
function useGuestGuard(_a) {
    var context = _a.context, children = _a.children, loader = _a.loader, redirectTo = _a.redirectTo;
    var _b = react_1.default.useContext(context), isInitialized = _b.isInitialized, isAuthenticated = _b.isAuthenticated;
    if (!isInitialized) {
        return loader || react_1.default.createElement(react_1.default.Fragment, null);
    }
    if (isAuthenticated) {
        if (redirectTo) {
            return react_1.default.createElement(react_router_dom_1.Navigate, { to: redirectTo, replace: true });
        }
    }
    else {
        return react_1.default.createElement(react_1.default.Fragment, null, children);
    }
    return react_1.default.createElement(react_1.default.Fragment, null);
}
exports.useGuestGuard = useGuestGuard;
